import QRCode from 'qrcode';
import api from '../../../Component/axios_Interceptor/api';
import { SERVER_ADDRESS } from '../../../Component/server';

export type ProductQrLabel = { seq: number; name: string; code: string };
export async function printProductQr(productSeqs: number[]) {
  const popup = window.open('', '_blank', 'width=920,height=800');
  if (!popup) throw new Error('QR 인쇄 창을 열 수 없습니다. 팝업 차단을 해제해주세요.');
  popup.opener = null;
  const doc = popup.document;
  doc.title = '팬버드 상품 QR 인쇄';
  doc.body.textContent = '선택한 상품의 QR을 준비하고 있습니다…';
  try {
    const { data } = await api.post<ProductQrLabel[]>(`${SERVER_ADDRESS}product/qr/labels`, { productSeqs });
    if (popup.closed) return;
    if (!Array.isArray(data) || data.length !== productSeqs.length) throw new Error('인쇄할 상품 목록을 확인해주세요.');
    const style = doc.createElement('style');
    // CL568: https://www.label.kr/Goods/Detail/568#specs (6 × 8, left 6mm, top 9mm, row gap 2.07mm).
    // The grid is 278.49mm tall, leaving the manufacturer's 9.51mm bottom margin on A4.
    style.textContent = `
      @page{size:A4 portrait;margin:9mm 6mm}
      *{box-sizing:border-box}
      body{margin:0;background:#eee;color:#000;font-family:Arial,sans-serif}
      header{padding:16px}
      header p{margin:8px 0;font-size:14px}
      button{padding:12px 24px;font-size:16px}
      .label-sheet{display:grid;grid-template-columns:repeat(6,33mm);grid-template-rows:repeat(8,33mm);column-gap:0;row-gap:2.07mm;width:198mm;height:278.49mm;margin:16px auto;background:#fff;break-inside:avoid;break-after:page}
      .label-sheet:last-child{break-after:auto}
      article{width:33mm;height:33mm;padding:1mm;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.5mm;overflow:hidden;outline:1px dashed #ccc;outline-offset:-1px}
      img{display:block;width:24mm;height:24mm;flex-shrink:0}
      article p{width:100%;height:6.5mm;flex-shrink:0;margin:0;font-size:8pt;line-height:1.1;text-align:center;overflow-wrap:anywhere;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}
      @media print{body{background:#fff}header{display:none}.label-sheet{margin:0}article{outline:none}}
    `;
    doc.head.append(style);
    const print = doc.createElement('button');
    print.textContent = 'QR 인쇄'; print.onclick = () => popup.print();
    const header = doc.createElement('header');
    const guide = doc.createElement('p');
    guide.textContent = '아이라벨 CL568 · 33 × 33mm · 6열 × 8행 (48칸) | A4 세로 · 배율 100%(실제 크기) · 머리글/바닥글 끄기';
    header.append(print, guide);
    const main = doc.createElement('main');
    doc.body.replaceChildren(header, main);
    let sheet: HTMLElement | undefined;
    // Keep generation sequential so large Excel selections do not allocate thousands of canvases at once.
    for (const product of data) {
      if (popup.closed) return;
      if (!sheet || sheet.childElementCount === 48) {
        sheet = doc.createElement('section');
        sheet.className = 'label-sheet';
        main.append(sheet);
      }
      const article = doc.createElement('article');
      const image = doc.createElement('img');
      image.alt = `${product.name} QR`;
      image.src = await QRCode.toDataURL(product.code, { errorCorrectionLevel: 'M', margin: 4, width: 360 });
      const name = doc.createElement('p'); name.textContent = product.name;
      article.append(image, name); sheet.append(article);
    }
    await Promise.all(Array.from(main.querySelectorAll('img')).map(img => img.decode().catch(() => {})));
    if (!popup.closed) { popup.focus(); popup.print(); }
  } catch (error) {
    if (!popup.closed) doc.body.textContent = 'QR을 준비하지 못했습니다. 상품 창고에서 다시 시도해주세요.';
    throw error;
  }
}
